jQuery(document).ready(function ($) {

  /* on scroll line fill js */
  let blocks = $(".left-right-alternate");

  // Throttle helper: limits function execution to once per 'limit' ms
  function throttle(func, limit) {
    let inThrottle;
    return function () {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }

  $(window).on("scroll", throttle(function () {

    const scrollTop = $(window).scrollTop();
    const windowCenter = scrollTop + ($(window).height() / 2);
    //alert("here");
    blocks.each(function () {

      const $block = $(this);
      const blockTop = $block.offset().top;
      const blockHeight = $block.outerHeight();
      const blockBottom = blockTop + blockHeight;

      // Activate when window center reaches block top
      if (windowCenter >= blockTop) {
        $block.addClass("active");
      } else {
        $block.removeClass("active");
      }

      // Fill percentage
      if ($block.hasClass("active")) {
        let progress = windowCenter - blockTop;
        let percent = (progress / blockHeight) * 100;

        // Keep between 0–100%
        percent = Math.max(0, Math.min(100, percent));

        this.style.setProperty("--fill", percent + "%");

      } else {
        this.style.setProperty("--fill", "0%");
      }

    });

  }, 16)); // ~60fps

  function loadVacatures(page = 1) {

    var regio = $(".js-vacature-regio-filter").val();
    var sector = $(".js-sector-filter").val();

    $("#page_no").val(page);

    var data = {
      action: "filter_vacature",
      pageNo: page,
      regio: regio,
      sector: sector
    };

    $(".js-vacature-loader").addClass("is-loading");

    $.ajax({
      type: "POST",
      url: "/wp/wp-admin/admin-ajax.php",
      dataType: "json",
      data: data,
      success: function (response) {
        console.log('res', response);
        $(".js-vacature-list").html(response.html);
        renderVacaturePagination(response.max, page);
      },
      error: function (xhr, status, error) {
        console.log('Error filtering vacancies:', { xhr, status, error });
        $(".js-vacature-list").html('<h2>Er ging iets mis bij het laden van de vacatures. Probeer het later opnieuw.</h2>');
        $(".js-vacature-pagination").empty();
      },
      complete: function () {
        $(".js-vacature-loader").removeClass("is-loading");
      }
    });
  }

  function renderVacaturePagination(maxPages, currentPage) {

    var html = '<ul class="list-unstyled">';

    if (currentPage > 1) {
      html += `
                    <li>
                        <a href="#" class="prev" data-page="${currentPage - 1}">
                            <img src="/app/uploads/2025/12/layer1.svg" class="pagi_icon leftIcon">
                        </a>
                    </li>`;
    }

    for (var i = 1; i <= maxPages; i++) {
      html += `
                    <li class="${i === currentPage ? 'active' : ''}">
                        <a href="#" data-page="${i}">${i}</a>
                    </li>`;
    }

    if (currentPage < maxPages) {
      html += `
                    <li>
                        <a href="#" class="next" data-page="${currentPage + 1}">
                            <img src="/app/uploads/2025/12/layer1.svg" class="pagi_icon rightIcon">
                        </a>
                    </li>`;
    }

    html += "</ul>";

    $(".js-vacature-pagination").html(html);
  }

  if ($(".js-vacature-pagination").length || $(".js-vacature-list").length) {

    $(".js-vacature-regio-filter, .js-sector-filter").on("change", function () {
      loadVacatures(1);
    });

    $(document).on("click", ".js-vacature-pagination a", function (e) {
      e.preventDefault();
      loadVacatures($(this).data("page"));
    });

    // List page 1 is rendered server-side; only build its pagination.
    renderVacaturePagination(parseInt($(".js-vacature-pagination").data("max"), 10) || 0, 1);
  }

  /* ===============================
   * LOAD COACHES (AJAX)
   * =============================== */
  function loadCoaches(page = 1) {

    var keyword = $(".js-coach-keyword").val();
    var regio = $(".js-coach-regio-filter").val();
    var jeugd = $(".js-jeugd-filter").val();

    $("#page_no").val(page);

    var data = {
      action: "filter_coach",
      pageNo: page,
      coach_keyword: keyword,
      regio: regio,
      jeugd: jeugd
    };

    $.ajax({
      type: "POST",
      url: "/wp/wp-admin/admin-ajax.php",
      dataType: "json",
      data: data,
      success: function (response) {
        $(".js-coach-list").html(response.html);
        renderCoachPagination(response.max, page);
        if (typeof coachMap !== "undefined" && typeof drawCoachMarkers === "function") {
          drawCoachMarkers(response.markers, true);
        }
      },
      error: function (xhr, status, error) {
        console.log('Error filtering coaches:', { xhr, status, error });
        $(".js-coach-list").html('<h2>Er ging iets mis bij het laden van de coaches. Probeer het later opnieuw.</h2>');
        $(".js-coach-pagination").empty();
      }
    });
  }

  /* ===============================
   * PAGINATION HTML
   * =============================== */
  function renderCoachPagination(maxPages, currentPage) {

    var html = '<ul class="list-unstyled">';
    if (currentPage > 1) {
      html += `
                <li>
                    <a href="#" class="prev" data-page="${currentPage - 1}">
                        <img src="/app/uploads/2025/12/layer1.svg" class="pagi_icon leftIcon">
                    </a>
                </li>`;
    }
    for (var i = 1; i <= maxPages; i++) {
      html += `
                <li class="${i === currentPage ? 'active' : ''}">
                    <a href="#" data-page="${i}">${i}</a>
                </li>`;
    }
    if (currentPage < maxPages) {
      html += `
                <li>
                    <a href="#" class="next" data-page="${currentPage + 1}">
                        <img src="/app/uploads/2025/12/layer1.svg" class="pagi_icon rightIcon">
                    </a>
                </li>`;
    }

    html += "</ul>";

    $(".js-coach-pagination").html(html);
  }

  /* ===============================
   * EVENTS
   * =============================== */

  /* Form submit (submit button click, enter key, etc.) */
  $(".js-coach-filter-form").on("submit", function (e) {
    e.preventDefault();
    loadCoaches(1);
  });

  /* Pagination click */
  $(document).on("click", ".js-coach-pagination a", function (e) {
    e.preventDefault();
    var page = $(this).data("page");
    loadCoaches(page);
  });

  /* Initial load */
  if ($(".js-coach-list").length) {
    loadCoaches(1);
  }

});
